import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon } from 'lucide-react';
const posts = ['https://cdn.magicpatterns.com/uploads/j8Dnr4XNVo2u5NFxYqF5Vz/Screenshot_2026-03-19_160206.png', 'https://cdn.magicpatterns.com/uploads/rybf9qXPeuuwtJct9pBWR4/Screenshot_2026-03-19_160143.png', 'https://cdn.magicpatterns.com/uploads/xae55UqHqhG4f2wHghEvQ2/Screenshot_2026-03-19_160128.png', 'https://cdn.magicpatterns.com/uploads/uq1gzwAqqgzrfnhA3BwdFd/Screenshot_2026-03-19_160114.png', 'https://cdn.magicpatterns.com/uploads/oWB37Cf5isF4iXL9cmjzC1/unnamed_(3).webp', 'https://cdn.magicpatterns.com/uploads/uZPGDAXUcxv2h2PRxGnT3C/unnamed_(2).webp', 'https://cdn.magicpatterns.com/uploads/9io7yx3BmLPZQwjKLXQQc9/unnamed_(1).webp', 'https://cdn.magicpatterns.com/uploads/s6Lf7SojeoCY8cGPB5rJ3J/unnamed.webp'];
export function IGSlider() {
  return <section className="py-16 md:py-24 bg-ivory overflow-hidden" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10" data-id="element-282">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4" data-id="element-283">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-284">
            <h2 className="font-display italic text-3xl md:text-4xl lg:text-6xl text-warm-brown" data-id="element-285">
              Trending on IG
            </h2>
          </motion.div>

          <motion.a initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-warm-brown font-bold uppercase tracking-widest text-sm hover:text-burnt-sienna transition-colors group" data-id="element-286">
            Follow @roziiepse
            <span className="transform group-hover:translate-x-1 transition-transform" data-id="element-287">
              →
            </span>
          </motion.a>
        </div>
      </div>

      {/* Infinite Sliding Marquee */}
      <div className="relative flex overflow-x-hidden py-4" data-id="element-288">
        <div className="flex items-center gap-4 md:gap-6 animate-marquee whitespace-nowrap" data-id="element-289">
          {[...posts, ...posts].map((src, index) => <a key={`a-${index}`} href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="relative w-44 h-44 sm:w-52 sm:h-52 md:w-64 md:h-64 rounded-2xl overflow-hidden shrink-0 group block shadow-lg border border-warm-brown/10" data-id="element-290">
              <img src={src} alt="Instagram post" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-291" />
              <div className="absolute inset-0 bg-near-black/0 group-hover:bg-near-black/20 transition-colors duration-300 flex items-center justify-center" data-id="element-292">
                <InstagramIcon className="w-8 h-8 text-cream opacity-0 group-hover:opacity-100 transform scale-50 group-hover:scale-100 transition-all duration-300" data-id="element-293" />
              </div>
            </a>)}
        </div>
        <div className="flex items-center gap-4 md:gap-6 animate-marquee2 whitespace-nowrap absolute top-4" data-id="element-294">
          {[...posts, ...posts].map((src, index) => <a key={`b-${index}`} href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="relative w-44 h-44 sm:w-52 sm:h-52 md:w-64 md:h-64 rounded-2xl overflow-hidden shrink-0 group block shadow-lg border border-warm-brown/10" data-id="element-295">
              <img src={src} alt="Instagram post" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-296" />
              <div className="absolute inset-0 bg-near-black/0 group-hover:bg-near-black/20 transition-colors duration-300 flex items-center justify-center" data-id="element-297">
                <InstagramIcon className="w-8 h-8 text-cream opacity-0 group-hover:opacity-100 transform scale-50 group-hover:scale-100 transition-all duration-300" data-id="element-298" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}